import { cn } from "@/lib/chillnn/cn";

import { BodyWrapper } from "@/components/ui/body/body-wrapper";

type Props = {
	header: React.ReactElement;
	tableBody: React.ReactElement;
};

export const ItemListContainer = ({ header, tableBody }: Props) => {
	return (
		<div className="relative m-4 max-w-full lg:m-12">
			<div
				className={cn(
					"flex w-full flex-col gap-y-6", //
				)}
			>
				<BodyWrapper>
					<div className="flex w-full flex-col gap-y-12">
						{header}

						<section className="flex flex-col gap-y-12 divide-y divide-zinc-100 [&>*:not(:first-child)]:pt-6">
							{tableBody}
						</section>
					</div>
				</BodyWrapper>
			</div>
		</div>
	);
};

ItemListContainer.displayName = "ItemListContainer";
